import teamsUpdated from "sh-stores/sh-teaminfo-store/actions/teamsUpdated";
import updateTeamsInStore from "sh-stores/sh-teaminfo-store/mutatorAction/updateTeamsInStore";
import { orchestrator } from "satcheljs";

export default orchestrator( teamsUpdated, async actionMessage => {
    // update the data in the store
    updateTeamsInStore(actionMessage.teams, actionMessage.resetExistingTeams);
});